var _module_exports = "<div class='pr-page-margin-positioner'>\n\t<ng-transclude></ng-transclude>\n</div>\n";;
var path = '/app/src/client/components/page/page-margin-positioner/page-margin-positioner.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;